import { filter } from 'lodash';
import React from 'react';

import { AlertLevels } from '@/constants/enums';

import { AlertsContainer } from './ControlCenterCompressorWidget.styles';
import SeverityIcon from '@/comp/common/icons/SeverityIcon';

type AlertItem = {
  icon: JSX.Element;
  count: number;
};

const Alerts = ({ activeOpenAlerts }: { activeOpenAlerts: unknown[] }) => {
  const alertSeveritySummaries: AlertItem[] = [
    {
      count: filter(activeOpenAlerts, { severity: AlertLevels.Shutdown })?.length,
      icon: <SeverityIcon severity={AlertLevels.Shutdown} />,
    },
    {
      count: filter(activeOpenAlerts, { severity: AlertLevels.Warning })?.length,
      icon: <SeverityIcon severity={AlertLevels.Warning} />,
    },
    {
      count: filter(activeOpenAlerts, { severity: AlertLevels.Service })?.length,
      icon: <SeverityIcon severity={AlertLevels.Service} />,
    },
  ];

  if (alertSeveritySummaries.every(alertSeverityItem => alertSeverityItem.count === 0)) return null;

  return (
    <AlertsContainer>
      <div className="alerts">
        {alertSeveritySummaries.map((alertSeverityItem, index) => {
          if (alertSeverityItem.count > 0) {
            return (
              <div className="alert-icon-count-container" key={index}>
                <span className="alert-icon">{alertSeverityItem.icon}</span>
                <span className="alert-count">{alertSeverityItem.count}</span>
              </div>
            );
          }
          return null;
        })}
      </div>
    </AlertsContainer>
  );
};

export default Alerts;
